<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/user']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'user_common_name' | translate"></nz-statistic>
    </a>
</nz-card>